import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from 'components/dialog/dialog';
import { AutomaticInput } from './AutomaticInput';
import { ManualInput } from './ManualInput';
import { useTranslation } from 'react-i18next';

export interface AnamnesisDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  error: string | null;
  onChange: (value: string) => void;
  onSubmit: (patient?: { medatixxId: string } | null) => unknown;
}

export const AnamnesisDialog: React.FC<AnamnesisDialogProps> = ({
  open,
  onOpenChange,
  value,
  error,
  onChange,
  onSubmit,
}) => {
  const [isManualMode, setIsManualMode] = useState(false);
  const [manualError, setManualError] = useState<string | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      setIsManualMode(false);
      setManualError(null);
    }
  }, [open]);

  const handleSwitchToManual = (errorMsg?: string) => {
    setIsManualMode(true);
    if (errorMsg) {
      setManualError(errorMsg);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle aria-label={t('home.anamnesisLookupDialog.title')} />
      <DialogContent>
        {!isManualMode ? (
          <AutomaticInput
            key={open ? 'open' : 'closed'}
            enabled={open}
            onSubmit={onSubmit}
            onSwitchToManual={handleSwitchToManual}
          />
        ) : (
          <ManualInput
            value={value}
            error={error || manualError}
            onChange={onChange}
            onSubmit={onSubmit}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
